export default {"src":"/_next/static/media/waypoint-logo-mark_on-light.858453de.svg","height":72,"width":64,"blurWidth":0,"blurHeight":0};